import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import "./notfound.scss"

const NotFound = () => {

    return (
        <motion.div
            className="notFound"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }} // Animationsdauer und Verlauf
        >
            <Helmet>
                <title>Error 404 | Musikkapelle St. Lorenzen</title>
            </Helmet>
            <div className="header">
                <h1>Error 404</h1>
                <p>Ups! Die Seite, die du suchst, konnte nicht gefunden werden. Vielleicht hast du dich vertippt oder die Seite existiert nicht mehr. Kein Problem, lass uns dich zurück zur Startseite bringen.</p>
                <Link to="/" className="lineLink">Zur Startseite</Link>
            </div>
        </motion.div>
    )
};

export default NotFound